import axios from "axios";
import router from "../router";
import { useToast } from "vue-toastification";
const toast = useToast();
// Add a request interceptor
axios.interceptors.request.use(
  config => {

    var date = new Date();
    var offset = date.getTimezoneOffset();
    let tempUser = JSON.parse(localStorage.getItem('user'))
    if (tempUser != null && tempUser !== 'undefined') {
      let user = JSON.parse(localStorage.getItem('user'))
      // config.headers.common['_token'] = user._token;
      config.headers.common['Authorization'] = 'Bearer ' + user._token
    }
    config.headers.common['Content-Type'] = 'application/json';
    config.baseURL = process.env.VUE_APP_API_URL;

    config.headers.common['Access-Control-Allow-Origin'] = '*';
    config.headers.common['meta'] = 'Platform: ConsumerMHH-Web, Version';
    config.headers.common['type'] = 'Consumer';
    config.headers.common['signature'] = 'debug';
    config.headers.common['tz'] = offset * -1
    config.headers.common['app-source'] = 'consumer-web-mhh'

    let client_identifier = localStorage.getItem("client_identifier") ?? ''
    if (client_identifier.length <= 0) {

      client_identifier = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16))

      localStorage.setItem("client_identifier", "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)))

    }

    if (client_identifier) {
      config.headers.common['client-identifier'] = client_identifier;

    }


    if ("post" === config.method.toLowerCase()) {


      if (undefined === config.data) {
        config.data = { timestamp: (new Date()).getTime() }
      } else {
        config.data.timestamp = (new Date()).getTime();
      }
    }
    if ("get" === config.method.toLowerCase()) {
      if (undefined === config.params) {
        config.params = { timestamp: (new Date()).getTime() }
      } else {
        config.params.timestamp = (new Date()).getTime();
      }
    }
    if ("put" === config.method.toLowerCase()) {

      if (undefined === config.params) {
        config.params = { timestamp: (new Date()).getTime() }
      } else {
        config.params.timestamp = (new Date()).getTime();
      }
    }

    return config;
  },
  error => {
    Promise.reject(error)
  });

//Add a response interceptor
axios.interceptors.response.use((response) => {

  if (response.data.error_code == 'job_access_denied') {
    window.location.replace("/not-found");
  }
  else if (response.data.error_code == 'invalid_token') {

    

    setTimeout(() => {
    
      localStorage.removeItem('user')
      localStorage.removeItem('isSilentLogin')
      localStorage.removeItem('isProtectionPlans')
      localStorage.removeItem('is_from_mobile')
      window.location = process.env.VUE_APP_HOME_PAGE_URL
      return response;

    }, 5000);
 
    // window.location.replace("/login");


  }
  else {
    // Do something with response data
    return response;
  }

}, function (error) {
    if (error.response.status == '404') {
      toast.error(error?.response?.data?.message || "Data not found.")
      router.replace({name:"workOrders"})
    }
  return Promise.reject(error);
});